import axios from "axios";
import { auth } from "./firebase";
import { endpoint } from "./shared";

export const apiClient = axios.create({
  baseURL: endpoint,
});

// Request interceptor: token letto al momento della request, non dal context snapshot
apiClient.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: retry su 401 con force refresh del token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const token = await auth.currentUser?.getIdToken(true);
      if (token) {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return apiClient(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);
